module.exports = __webpack_public_path__ + "img/alex8.3ab2c40c.png";